<template>
    <div class="animated fadeIn">

        <div style="min-height: 400px;">
            <b-row>
                <b-col cols="auto" class="mr-auto">
                </b-col>
                <b-col cols="auto" class="">
                    <b-form-group>
                        <b-button variant="github" class="mr-1 btn-brand" @click="openModal()" :disabled="!inventory || inventory.id <= 0"><i class="fa fa-plus"></i><span>Nova Faixa de Etiqueta</span></b-button>
                    </b-form-group>
                </b-col>
            </b-row>
            
            <b-table :items="items" :fields="table.fields" :select-mode="table.selectMode" responsive="sm" primary-key="id" 
                    :tbody-transition-props="table.transProps" sort-icon-left
                    per-page="50" current-page="1" :busy="table.isBusy" hover striped style="min-height: 200px;"                    
                    >

                <template #cell(show_details)="row">
                    <b-row>
                        <b-col cols="auto" class="mr-auto">
                            <b-form-group>
                            <b-button size="sm" variant="primary"  @click="row.toggleDetails" class="mr-1 btn-brand"><i class="fa fa-search"></i></b-button>
                            </b-form-group>
                        </b-col>
                    </b-row>
                </template>
                
                <template #row-details="row">
                    <b-card>
                        <b-row v-show="row.item.notes && row.item.note != ''">
                            <b-col class="text-primary">{{ row.item.notes }}</b-col>
                        </b-row>

                    </b-card>
                </template>

                <template v-slot:cell(attachment)="data">
                    <b-button v-show="data.item.fileUrl" size="sm" variant="primary" class="mr-1 btn-brand" @click="openModal(data.item)"><i class="fa fa-file-o"></i></b-button>
                </template>
                
                <template v-slot:cell(action)="data">
                    <b-button size="sm" variant="danger" @click="deleteItem(data.item)" class="mr-1 btn-brand"><i class="fa fa-times"></i></b-button>                  
                </template>

            </b-table>

            <b-modal v-model="editModal"
                id="edit-modal"
                centered
                hide-footer
                title="Faixas do Setor"
                size="md">

                <inventory-sector-label-component :item="selectedItem" :inventory="currentInventory" :companyId="companyId" @response="handleSave"></inventory-sector-label-component>
                
            </b-modal>

            <b-modal title="Excluir Faixa" centered class="modal" v-model="deleteRangeModal" @ok="sendDeleteItem" cancel-title="Cancelar">
                <div>Deseja realmente excluir a faixa de etiquetas selecionada?</div>
            </b-modal>
            
        </div>

    </div>  
</template>


<script>
import Vue from 'vue'
import axios from "axios";

import InventorySectorLabelComponent from './InventorySectorLabelComponent'

/* Toast */
import VueNotifications from 'vue-notifications'
import miniToastr from 'mini-toastr'// https://github.com/se-panfilov/mini-toastr
//import { table } from 'console'
import InventoryPrintComponent from './InventoryPrintComponent';
import InventorySectorLabelGridComponent from './InventorySectorLabelGridComponent'

const toastTypes = {
  success: 'success',
  error: 'error',
  info: 'info',
  warn: 'warn'
}

miniToastr.init({types: toastTypes})

function toast ({title, message, type, timeout, cb}) {
  return miniToastr[type](message, title, timeout, cb)
}

const options = {
  success: toast,
  error: toast,
  info: toast,
  warn: toast
}
VueNotifications.setPluginOptions(options)

Vue.use(VueNotifications, options)
/* Toast - End */

export default {
    name: 'inventorySectorLabelGridComponent',
    props: {
        inventory: {},
        companyId: Number
    },
    components: {
        InventorySectorLabelComponent
    },
    data: () => {
        return {
            selectedItem: {},
            deleteRangeModal: false,
            editModal: false,
            items: [],
            table: {
                fields: [
                    //{key: 'show_details', label: "", thStyle: { width: "30px" } },
                    { key: 'stockLocation.name', label: 'Setor', sortable: true },
                    { key: 'labelStart', label: 'Etiqueta Inicial', sortable: true, thStyle: { width: "120px" }, tdClass: 'text-center' },
                    { key: 'labelEnd', label: 'Etiqueta Final', sortable: true, thStyle: { width: "120px" }, tdClass: 'text-center' },
                    //{ key: 'quantity', label: 'Quantidade', thStyle: { width: "120px" } },
                    //{ key: 'itemDiscount', label: 'Desconto', sortable: false, thStyle: { width: "120px" } },
                    //{ key: 'totalValue', label: 'Valor Total', thStyle: { width: "120px" }, tdClass: 'text-right' }
                    //{ key: 'description', label: 'Descrição', sortable: true},
                    { key: 'action', label: '', sortable: false, thStyle: { width: "25px" } },                    
                    //{key: 'attachment', label: "", thStyle: { width: "25px" } },
                    
                ],
                selectMode: 'single',
                isBusy: false,
                primaryKey: "id",
                transProps: {
                    name: 'flip-list'
                }

            },
            
        }
    },
    computed: {
        
         currentInventory() {
            return this.inventory
        },
    },
    methods: {
        handleSave(obj) {

            
            if(obj && obj.code && obj.code == 1) {
                this.refreshData()
                this.editModal = false
            }
            else {
                toast ({
                    type: VueNotifications.types.error,
                    title: 'Faixa',
                    message: obj && obj.message ? obj.message : 'Faixa já cadastrada. Verifique e tente novamente',
                    timeout: 5000
                })
            }
                
        },
        deleteItem(item) {
            this.selectedItem = item
            this.deleteRangeModal = true
        },
        async sendDeleteItem() {
            var s = this
            var currentUser = this.$store.state.currentUser;

            var url = this.$store.state.ws_url + "/stock/location/label?id=" + s.selectedItem.id + "&uid=" + currentUser.id + "&sid=" + currentUser.sid
            await axios.delete(url
            ).then(function(resp) {
                s.refreshData()
            }).catch(function(error) {
                console.log(error)
            })
        },
        openModal(item) {
            if(item == null) {
                this.selectedItem = { id: null, stockLocationId: null, labelStart: null, labelEnd: null }
            }
            else {
                this.selectedItem = item          
            }
            this.editModal = true
        },
        closeModal() {
            this.editModal = false
        },

        rowClicked(item) {
            this.openModal(item);
        },

        async refreshData() {
            var s = this
            var currentUser = this.$store.state.currentUser;


            await axios.get(
                this.$store.state.ws_url + "/stock/location/label?inventoryId=" + s.currentInventory.id + "&uid=" + currentUser.id + "&sid=" + currentUser.sid
            ).then(function(resp) {
                s.items = resp.data.obj
            }).catch(function(error) {
                console.log(error)
            })
        }
    },
    mounted: function() {
        this.refreshData()
    }

}

</script>